import { findLast } from "lodash-es";
import {
  SessionPartWithContext,
  SessionPartKind,
  ReasoningV1SessionPart,
} from "@/mds/components/sessions/session.types";
import {
  SESSION_THOUGHT_PROCESS_TEXTS,
  SESSION_TEXT_DISPLAY_CONFIG,
} from "./thought-process.constants";

/**
 * Truncates text if it exceeds the maximum length, adding an ellipsis
 */
function truncateTextIfNeeded(text: string): string {
  if (text.length <= SESSION_TEXT_DISPLAY_CONFIG.MAX_HEADER_LENGTH) {
    return text;
  }

  const endIndex =
    SESSION_TEXT_DISPLAY_CONFIG.MAX_HEADER_LENGTH - SESSION_TEXT_DISPLAY_CONFIG.TRUNCATION_BUFFER;
  const truncatedText = text.substring(0, endIndex);
  return `${truncatedText}${SESSION_TEXT_DISPLAY_CONFIG.TRUNCATION_SUFFIX}`;
}

/**
 * Extracts the first line from text content and cleans it up
 */
function extractFirstLine(content: string): string {
  const lines = content.split("\n");
  const firstLine = lines[0].trim();
  return firstLine;
}

/**
 * Extracts the latest thinking text from the reasoning parts.
 * This looks at the most recent reasoning part and displays its summary
 * as the current thinking status.
 */
export function extractLatestThinkingText(parts: SessionPartWithContext[]): string {
  if (parts.length === 0) {
    return SESSION_THOUGHT_PROCESS_TEXTS.THINKING;
  }

  const mostRecentReasoningPart = findLast(
    parts,
    partWithContext => partWithContext.part.kind === SessionPartKind.ReasoningV1
  );

  if (!mostRecentReasoningPart) {
    return SESSION_THOUGHT_PROCESS_TEXTS.PROCESSING;
  }

  const reasoningPart = mostRecentReasoningPart.part as ReasoningV1SessionPart;
  const firstLine = extractFirstLine(reasoningPart.summary);

  if (!firstLine) {
    return SESSION_THOUGHT_PROCESS_TEXTS.PROCESSING;
  }

  return truncateTextIfNeeded(firstLine);
}
